import { Checkbox, Drawer, Image, List } from "antd";
import { useState } from "react";

const ConsentModal = (props) => {
  const { open, onClose, onConsentSubmit, dynamicConsent } = props;
  const [isAgreed, setIsAgreed] = useState(true);
  const handleSubmit = () => {
    if (onConsentSubmit) onConsentSubmit(true);
  };

  const data = [
    {
      title: "Access to Camera & Photos",
      description:
        "<p>AFI Dhanvridhi requires access to your device’s camera and photo library for identity verification purposes.</p>",
      src: imagepaths.cameraDarkIcon,
    },
    {
      title: "Customer Consent & Communication",
      description: `<p class="mb-2">By continuing, you:</p>
      <ul class="ps-3">
            <li>• Agree to our [Terms & Conditions] and [Privacy Policy]</li>
            <li>• Authorize us to contact you via SMS, WhatsApp, email, and phone for application updates, support, feedback, EMI/Repayment/Collections Reminders and loan servicing.</li>
        </ul>
        `,
      src: imagepaths.userProfilePersonIcon,
    },
    {
      title: "Credit Bureau Authorization",
      description: `<p>I/We authorize AFI Dhanvridhi and its representatives to access my/our credit information from any registered Credit Information Company (CIC), including:</p>
      <ul class="ps-3 mb-3">
            <li><b>• TransUnion CIBIL</b></li>
            <li><b>• CRIF High Mark</b></li>
            <li><b>• Experian</b></li>
            <li><b>• Equifax</b></li>
        </ul>
        <p>This is solely for assessing my/our loan application.</p>
        `,
      src: imagepaths.creditbureauIcon,
    },
    {
      title: "Access to Installed Apps",
      description: `<p>To better personalize your loan offers, AFI Dhanvridhi may collect non-sensitive metadata from apps on your device (e.g., app name, install date, version).</p>`,
      src: imagepaths.mobileCodeAppIcon,
    },
    {
      title: "Consent to Collect, Store, and Use Personal Data",
      description: `<p>I/We understand and agree that Ayaan Finserve India Pvt. Ltd. may:</p>
      <p>1. Collect, verify, store, and use my/our personal, financial, transactional, and demographic data including but not limited to:</p>
      <ul class="ps-3 mb-3">
            <li>• Name, mobile number, address, PAN, Aadhaar, KYC documents</li>
            <li>• Bank statements, salary/income details</li>
            <li>• Loan history and repayment behavior</li>
        </ul>
      <p>2. Use this data for purposes including:</p>
      <ul class="ps-3 mb-3">
            <li>• Credit appraisal and risk assessment</li>
            <li>• Loan processing, disbursal, monitoring, and recovery</li>
            <li>• Regulatory reporting and internal audits</li>
            <li>• Product improvement, analytics, and fraud detection</li>
            <li>• Communicating offers or services (only as permitted under applicable laws)</li>
        </ul>
        `,
      src: imagepaths.userProfilePersonIcon,
    },
    {
      title: "Consent to Share Information:",
      description: `<p>I/We also authorize Ayaan Finserve India Pvt. Ltd. to share my/our data with credit bureaus, regulators, collection agencies, verification partners, or service providers, as required for processing my/our application and complying with applicable laws.</p>`,
      src: imagepaths.userProfilePersonIcon,
    },
    {
      title: "Digital Communication Consent",
      description: `<p>I/We consent to be contacted via SMS, phone call, email, or any other digital medium for loan-related communication, status updates, reminders, and promotional offers (as permitted by law).</p>`,
      src: imagepaths.plainMailIcon,
    },
  ];

  if (props.dynamicConsent) {
    data.unshift({
      title: props.dynamicConsent.title || "Dynamic Consent",
      description: `<p>${props.dynamicConsent.consentData}</p>`,
      src: imagepaths.userProfilePersonIcon,
    });
  }

  const onChange = (e) => {
    let value = e.target.checked;
    setIsAgreed(!value);
  };

  return (
    <Drawer
      title="Consent & Disclosures – AFI Dhanvridhi"
      placement="right"
      onClose={onClose}
      open={open}
      width={500}
      maskClosable={false}
    >
      <p>Please review and accept the following before continuing:</p>
      <List
        itemLayout="horizontal"
        dataSource={data}
        style={{ paddingBottom: 140 }}
        renderItem={(item, index) => (
          <List.Item>
            <List.Item.Meta
              avatar={
                <Image
                  width={20}
                  height="auto"
                  preview={false}
                  src={item.src}
                />
              }
              title={item.title}
              description={
                <div dangerouslySetInnerHTML={{ __html: item.description }} />
              }
            />
          </List.Item>
        )}
      />

      <div className="filter_modal_footer_actions">
        <Checkbox
          onChange={onChange}
          style={{ color: "#817575" }}
          className="mb-3 pt-2 pb-3"
        >
          <p className="fs-6 m-0">
            I agree to the above and accept the Terms & Privacy Policy
          </p>
        </Checkbox>
        <div className="w-100 d-flex justify-content-end pb-4">
          <button
            className="btn btn-primary-lite me-3"
            type="button"
            onClick={onClose}
          >
            I Disagree
          </button>
          <button
            className="btn btn-primary bg_gradient"
            type="submit"
            onClick={handleSubmit}
            disabled={isAgreed}
          >
            I Agree & Continue
          </button>
        </div>
      </div>
    </Drawer>
  );
};

export default ConsentModal;
